module.exports = __webpack_public_path__ + "img/1.ab481bbb.png";